import { render } from "./YourDetailsDRW.vue?vue&type=template&id=4b4533cc&scoped=true"
import script from "./YourDetailsDRW.vue?vue&type=script&lang=js"
export * from "./YourDetailsDRW.vue?vue&type=script&lang=js"

import "./YourDetailsDRW.vue?vue&type=style&index=0&id=4b4533cc&lang=scss"
import "./YourDetailsDRW.vue?vue&type=style&index=1&id=4b4533cc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4533cc"]])

export default __exports__